import type { UsePushNotifications } from "@/hooks/usePushNotifications/index.shared";

/**
 * Web implementation of usePushNotifications
 *
 * Web does not support push notifications, so this provides a no-op implementation
 * that always reports push as disabled.
 */
const usePushNotifications = (): UsePushNotifications => {
  return {
    hasAnsweredPushNotificationPrompt: false,
    isPushNotificationsDisabled: true,
    isPushNotificationsInitialized: true,
    pushToken: null,
    registerForPushNotifications: async () => false,
  };
};

export default usePushNotifications;
